import { render } from "./QuestionsView.vue?vue&type=template&id=2427295c&ts=true"
import script from "./QuestionsView.vue?vue&type=script&lang=ts"
export * from "./QuestionsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Admin/Questions/QuestionsView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2427295c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2427295c', __exports__)) {
    api.reload('2427295c', __exports__)
  }
  
  module.hot.accept("./QuestionsView.vue?vue&type=template&id=2427295c&ts=true", () => {
    api.rerender('2427295c', render)
  })

}


export default __exports__